import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useEffect, useState } from "react";
import "./component/css/index.css";
import "./component/css/responsive.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Navbar from "./component/layout/Navbar";
import Footer from "./component/layout/Footer";
import Home from "./component/pages/Home";
import About from "./component/pages/About";
import Converter from "./component/pages/Converter";
import Blog from "./component/pages/Blog";
import Contact from "./component/pages/Contact";
import { MdLightMode } from "react-icons/md";
import { MdDarkMode } from "react-icons/md";

function App() {
  const [theme , setTheme] = useState('light-theme')
  const [themeIcon , setThemeIcon] = useState(<MdLightMode/>)

  const toggleTheme = () => {
    if(theme === 'light-theme') {
      setTheme('dark-theme')
      setThemeIcon(<MdDarkMode/>)
    } else {
      setTheme('light-theme')
      setThemeIcon(<MdLightMode/>)
    }
  }

  useEffect(() => {
    document.body.className=theme
    Aos.init({
      duration: 1000, 
    });
  }, [theme]);

  return (
    <div>
      <button className="theme-btn" onClick={toggleTheme} >{themeIcon}</button>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/converter" element={<Converter />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
